//
//
//
//
//
//
//
//
//
//
//

import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";

export default {
    components: {
        AQDropdown
    },
    props: {
        uuid: {
            type: String,
            default: ""
        },
        value: {
            type: String
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const vm = this;

        return {
            inputValue: null,
            priorityOptions: [
                {
                    label: vm.$t("diagrams.components.taskPriority.lowest"),
                    value: "lowest",
                    svgIcon: { name: require("@/assets/images/lowest_priority.svg"), size: "24px" }
                },
                {
                    label: vm.$t("diagrams.components.taskPriority.low"),
                    value: "low",
                    svgIcon: { name: require("@/assets/images/low_priority.svg"), size: "24px" }
                },
                {
                    label: vm.$t("diagrams.components.taskPriority.normal"),
                    value: "normal",
                    svgIcon: { name: require("@/assets/images/normal_priority.svg"), size: "24px" }
                },
                {
                    label: vm.$t("diagrams.components.taskPriority.high"),
                    value: "high",
                    svgIcon: { name: require("@/assets/images/high_priority.svg"), size: "24px" }
                },
                {
                    label: vm.$t("diagrams.components.taskPriority.highest"),
                    value: "highest",
                    svgIcon: { name: require("@/assets/images/highest_priority.svg"), size: "24px" }
                }
            ],
            defaultValue: ""
        };
    },
    watch: {
        inputValue: {
            handler(v) {
                if (this.readonly) {
                    return;
                }
                this.$emit("input", v && v[0] ? v[0].value : null);
            }
        },
        value: {
            handler(newVal) {
                this.defaultValue = newVal || "normal";
            },
            immediate: true
        }
    }
};
